var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import Base from "../../Base.js";
import Events from "../../mixin/Events.js";
import Factoryable from "../../mixin/Factoryable.js";
import Widget from "../../widget/Widget.js";
import DomHelper from "../../helper/DomHelper.js";
class Layout extends Base.mixin(Events, Factoryable) {
  get contentElement() {
    var _a;
    return (_a = this.owner) == null ? void 0 : _a.contentElement;
  }
  onChildAdd(item) {
  }
  onChildRemove(item) {
  }
  renderChildren() {
    const me = this, { owner, itemCls } = me, { contentElement, items } = owner, ownerItemCls = owner.itemCls, itemCount = items == null ? void 0 : items.length;
    if (itemCount) {
      owner.textContent = false;
      for (let insertion, renderTo, i = 0; i < itemCount; i++) {
        const item = items[i], { element, positionable } = item, { classList } = element;
        element.dataset.itemIndex = i;
        if (classList.contains("b-outer")) {
          classList.remove(...Widget.outerCls);
        }
        if (itemCls) {
          classList.add(itemCls);
        }
        if (ownerItemCls) {
          classList.add(ownerItemCls);
        }
        renderTo = contentElement;
        if (positionable) {
          insertion = owner.getPositionableLocation(positionable);
          if (!(renderTo = insertion[0])) {
            renderTo = insertion[1].parentElement;
            item.insertBefore = insertion[1];
          }
        }
        item.render(renderTo, Boolean(owner.isPainted));
      }
    }
    me.syncPendingConfigs();
    me.syncChildCount();
  }
  removeChild(child) {
    const me = this, { element } = child, { owner, itemCls } = me, { contentElement } = owner, ownerItemCls = owner.itemCls;
    if (contentElement.contains(element)) {
      element.remove();
    }
    delete element.dataset.itemIndex;
    if (itemCls) {
      element.classList.remove(itemCls);
    }
    if (ownerItemCls) {
      element.classList.remove(ownerItemCls);
    }
    me.fixChildIndices();
    me.syncChildCount();
  }
  appendChild(child) {
    const { element } = child, { owner, itemCls } = this, { contentElement } = owner, ownerItemCls = owner.itemCls;
    element.dataset.itemIndex = owner.indexOfChild(child);
    owner.textContent = false;
    if (itemCls) {
      element.classList.add(itemCls);
    }
    if (ownerItemCls) {
      element.classList.add(ownerItemCls);
    }
    child.render(contentElement, Boolean(owner.isPainted));
    this.syncChildCount();
  }
  insertChild(toAdd, childIndex) {
    const me = this, { element } = toAdd, { owner, itemCls } = me, { contentElement } = owner, nextSibling = DomHelper.getChild(contentElement, `[data-item-index="${childIndex}"]`), ownerItemCls = owner.itemCls;
    owner.textContent = false;
    if (itemCls) {
      element.classList.add(itemCls);
    }
    if (ownerItemCls) {
      element.classList.add(ownerItemCls);
    }
    contentElement.insertBefore(element, nextSibling);
    toAdd.render(null, Boolean(owner.isPainted));
    me.fixChildIndices();
    me.syncChildCount();
  }
  fixChildIndices() {
    this.owner.items.forEach((child, index) => {
      child.element.dataset.itemIndex = index;
    });
  }
  syncChildCount() {
    var _a;
    const { owner } = this, { length } = owner.items;
    (_a = owner.contentElement) == null ? void 0 : _a.classList[length === 1 ? "add" : "remove"]("b-single-child");
  }
  /**
   * Registers a layout `config` property that cannot be acted upon at this time but must wait for the `owner` to
   * fully render its elements (in particular the `contentElement`).
   * @param {String} config The name of the config to sync later.
   * @internal
   */
  syncConfigLater(config) {
    const pendingConfigs = this.pendingConfigs || (this.pendingConfigs = []);
    if (!pendingConfigs.includes(config)) {
      pendingConfigs.push(config);
    }
  }
  /**
   * Sets the specified `style` to the value of the config given its `name`.
   * @param {Object} options The name of the config with the value to apply to the given `style`.
   * @param {String} options.name The name of the config with the value to apply to the given `style`.
   * @param {String} options.style The style property to set on the `contentElement`.
   * @param {String[]} [options.classes] A list of config values that should be added as CSS classes.
   * @param {Object} [options.map] An mapping object to convert the config's value to the `style` value.
   * @internal
   */
  syncConfigStyle({ name, style, classes, map }) {
    const me = this, baseCls = `b-box-${name}-`, { contentElement } = me, raw = me[name];
    let value = (map == null ? void 0 : map[raw]) || raw;
    if (contentElement) {
      if (classes) {
        const { classList } = contentElement;
        classes.forEach((c) => {
          if (c !== value) {
            classList.remove(baseCls + c);
          }
        });
        if (classes.includes(value)) {
          classList.add(baseCls + value);
          value = "";
        }
      }
      contentElement.style[style] = value;
    } else {
      me.syncConfigLater(name);
    }
  }
  syncPendingConfigs() {
    const me = this, { pendingConfigs } = me;
    let name;
    if (pendingConfigs) {
      me.pendingConfigs = null;
      while (name = pendingConfigs.pop()) {
        me[me.$meta.configs[name].updater](me[name]);
      }
    }
  }
}
__publicField(Layout, "type", "default");
__publicField(Layout, "configurable", {
  /**
   * The owning Widget.
   * @member {Core.widget.Widget} owner
   * @readonly
   */
  /**
   * @config {Core.widget.Widget} owner
   * @private
   */
  owner: null,
  /**
   * The CSS class which should be added to the owning {@link Core.widget.Container}'s.
   * {@link Core.widget.Widget#property-contentElement}.
   * @config {String}
   */
  containerCls: "b-auto-container",
  /**
   * The CSS class which should be added to the encapsulating element of child items.
   * @config {String}
   */
  itemCls: null
});
// establish this class as the Factoryable base
__publicField(Layout, "factoryable", {
  defaultType: "default"
});
Layout.initClass();
Layout._$name = "Layout";
export {
  Layout as default
};
